import { Grid2, Paper } from '@mui/material';
import React, { FC } from 'react';
import * as Yup from 'yup';
import { Button } from '../../../Components/Form/Button/button.scomponent';
import { Input } from '../../../Components/Form/Input/input.component';
import { Loader } from '../../../Components/Loader';
import { BaseContentPage } from '../../../Components/Templates/BaseContentPage/base-content-page.componen';
import { BaseScreen } from '../../../Components/Templates/BaseScreen/basescreen.component';

import { CreateCategoriesUseCase } from '../../../Usecase/Categories/create-categories-usecase';
import { useCreateCategories } from './categories-create.hook';
import { ShowCategoriesUseCase } from '../../../Usecase/Categories/show-categories-usecase';
import { UpdateCategoriesUseCase } from '../../../Usecase/Categories/update-categories-usecase';
import { Radio } from '../../../Components/Form/Radio/radio-input.component';
import { Can } from '../../../Components/Can';


interface ProductProps {
    name: string;
    code: string;
    ncm: string;
    personalized: boolean
    createOnNuvemShop: boolean;
    createOnOmie: boolean;
    createOnb2b: boolean;
    createOnb2c: boolean;
    price: string
    description: string
  }
  
  
const SignInSchemaValidation = Yup.object().shape({
    name: Yup.string().required('Nome é obrigatório'),
    code: Yup.string(),
    ncm: Yup.string(),
    personalized: Yup.boolean(),
    createOnNuvemShop: Yup.boolean(),
    createOnOmie: Yup.boolean(),
    price: Yup.string().required('Preço Unitário é obrigatório'),
    description: Yup.string(),
    createOnb2b: Yup.boolean(),
    createOnb2c: Yup.boolean(),
  });



  interface ICategoryFormProps {
    createCategoriesUseCase: CreateCategoriesUseCase
    showCategoriesUseCase: ShowCategoriesUseCase
    updateCategoriesUseCase: UpdateCategoriesUseCase
  }

 
const CategoriesForm : FC<ICategoryFormProps> = ({ createCategoriesUseCase, showCategoriesUseCase, updateCategoriesUseCase }) => {

    const {handleAction, handleSubmit, loading, register, heightValue, lengthValue, setHeightValue, setLenghValue, setWidthValue, widthValue, errors, data, storeTypeOptions, control } = useCreateCategories({
      createCategoriesUseCase,
      showCategoriesUseCase,
      updateCategoriesUseCase
    })

    
    return (
      <Can permissions={['menu:categories:manage']}>
        <BaseScreen>
         
            <Paper >
                <BaseContentPage 
                    title='Categorias / Marcas'
                    breadcrumb={[{ title: 'Categorias - Marcas', link: "/categories-list"}, { title: 'Nova Categoria / Marca'}]}
                >

                {loading && <Loader />}

                <Grid2 container spacing={5} sx={{ marginTop: 2}} component="form" onSubmit={handleSubmit(handleAction)}>


                <Grid2 size={6}>
                    <Input
                        label="Nome da Categoria / Marca"
                        placeholder="Preencher com o nome da categoria / marca"
                        error={!!errors.name}
                        helperText={errors.name?.message}
                        {...register('name')}
                        
                    />
                </Grid2>

                <Grid2 size={6}>
                    <Input
                        label="Nome amigável"
                        placeholder="Preencher com o nome amigável da categoria / marca"
                        error={!!errors.friendlyUrl}
                        helperText={errors.friendlyUrl?.message}
                        {...register('friendlyUrl')}
                        
                    />
                </Grid2>     

                <Grid2 size={12}  sx={{ minWidth: '150px', flex: '0 0 auto' }}>
                        <Radio
                            label="Cadastrar em qual loja"
                            labelStyle={{ fontWeight: 'bold', fontSize: '18px', marginBottom: '20px'}}
                            name="nsStore"
                            control={control}
                            options={storeTypeOptions}
                            error={!!errors.store}
                            helperText={errors?.store?.message}
                            flex
                        />   
                </Grid2>

                          

                <Button type="submit" sx={{ marginTop: '10px', width: '200px' }} isLoading={loading}>
                    SALVAR
                </Button>
                </Grid2>

              </BaseContentPage>
              
            </Paper>
                
        </BaseScreen>
      </Can>
    )
}

export { CategoriesForm };
